import React, { useState } from "react";
import { Link } from "react-router-dom"; 
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import SawariLogo from '../../assets/sawari-logo.png';

export default function Header() {
  const [mobileMenu, setMobileMenu] = useState(false);

  const scrollToBooking = () => {
    document.getElementById("find-your-booking")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="w-full bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between relative z-50 shadow-sm">
      {/* Logo */}
      <Link to="/" className="flex items-center">
        <img src={SawariLogo} alt="Sawari Logo" className="h-10 w-auto object-contain" />
      </Link>

      {/* Navigation Links */}
      <nav className="hidden md:flex items-center space-x-8 font-semibold">
        <Link to="/airport-transfers" className="!text-[#00401A] !hover:text-[#00803e] transition text-base no-underline">
          Airport Transfers
        </Link>
        <Link to="/vehicle-rentals" className="!text-[#00401A] !hover:text-[#00803e] transition text-base no-underline">
          Vehicle Rentals
        </Link>
        <Link to="/tourism-packages" className="!text-[#00401A] !hover:text-[#00803e] transition text-base no-underline">
          Tourism Packages
        </Link>
      </nav>

      {/* Action Button */}
      <div className="hidden md:flex items-center">
        <button 
          onClick={scrollToBooking} 
          className="bg-[#00401A] !text-white px-6 py-2.5 rounded-lg font-medium hover:bg-emerald-950 transition shadow-sm text-sm border-0 cursor-pointer"
        >
          Track My Booking
        </button>
      </div>

      {/* Mobile Hamburger */}
      <div className="md:hidden flex items-center">
        <button 
          onClick={() => setMobileMenu(!mobileMenu)} 
          className="text-gray-700 text-xl bg-transparent border-0 cursor-pointer flex items-center"
        >
          {mobileMenu ? <CloseOutlined className="text-[#00401A]" /> : <MenuOutlined className="text-[#00401A]" />}
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenu && (
        <div className="absolute top-full left-0 w-full bg-white border-b border-gray-200 shadow-lg md:hidden flex flex-col p-4 space-y-3 z-50">
          <Link to="/airport-transfers" onClick={() => setMobileMenu(false)} className="text-[#00401A] font-semibold p-2 rounded-md hover:bg-gray-50 block no-underline">
            Airport Transfers
          </Link>
          <Link to="/vehicle-rentals" onClick={() => setMobileMenu(false)} className="text-[#00401A] font-semibold p-2 rounded-md hover:bg-gray-50 block no-underline">
            Vehicle Rentals
          </Link>
          <Link to="/tourism-packages" onClick={() => setMobileMenu(false)} className="text-[#00401A] font-semibold p-2 rounded-md hover:bg-gray-50 block no-underline">
            Tourism Packages
          </Link>
          <button 
            onClick={() => { setMobileMenu(false); scrollToBooking(); }} 
            className="w-full bg-[#00401A] text-white py-2 rounded-lg font-medium text-center text-sm border-0 cursor-pointer"
          >
            Track My Booking
          </button>
        </div>
      )}
    </header>
  );
}